"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownStyles = {
  dropdown: {
    display: 'inline-block',
    position: 'relative'
  },
  underlay: {
    display: 'inline-block',
    cursor: 'pointer'
  },
  overlayContent: {
    padding: '16px 20px 20px 20px'
  }
};